import React from 'react';

/**
 * SkillAnalyzerCard
 * A single selected skill card showing:
 * - skill icon + name
 * - scenario selector pills
 * - remove button
 */

// Helper: skill icon URL — same pattern as SkillDetailHeader.js
const getIconUrl = (icon_id) =>
    `/images/Icon/Skill_Icons/icon_skill_${icon_id}.png`;

const SkillAnalyzerCard = ({ skill, onRemove, onScenarioChange }) => {
    const { skillName, icon_id, skill_effects = [], chosenScenario } = skill;

    return (
        <div className="flex items-start gap-3 p-3 rounded-xl
            bg-slate-800 border border-slate-700
            hover:border-slate-600 transition-colors group">

            {/* Skill icon */}
            <div className="w-10 h-10 rounded-lg overflow-hidden flex-shrink-0 bg-slate-700 mt-0.5">
                <img
                    src={getIconUrl(icon_id)}
                    alt={skillName}
                    className="w-full h-full object-contain"
                    loading="lazy"
                />
            </div>

            {/* Main info */}
            <div className="flex-1 min-w-0">
                <p className="text-sm font-bold text-slate-100 truncate leading-tight mb-1.5">
                    {skillName}
                </p>

                {/* Scenario pills */}
                {skill_effects.length > 1 ? (
                    <div className="flex flex-wrap gap-1">
                        {skill_effects.map((fx, i) => {
                            const isActive = fx.group_id === chosenScenario;
                            return (
                                <button
                                    key={fx.group_id ?? i}
                                    onClick={() => onScenarioChange(skill.Id_skill, fx.group_id)}
                                    className={`text-[9px] font-bold px-2 py-0.5 rounded-full border transition-all
                                        ${isActive
                                            ? 'bg-violet-600/80 border-violet-500 text-white'
                                            : 'bg-slate-700 border-slate-600 text-slate-400 hover:border-violet-500/50 hover:text-slate-200'
                                        }`}
                                >
                                    Sc.{i + 1}
                                </button>
                            );
                        })}
                    </div>
                ) : (
                    <span className="text-[9px] text-slate-500 italic">Single scenario</span>
                )}
            </div>

            {/* Remove button */}
            <button
                onClick={() => onRemove(skill.Id_skill)}
                className="flex-shrink-0 w-6 h-6 rounded-full
                    text-slate-500 hover:text-rose-400 hover:bg-rose-900/20
                    flex items-center justify-center
                    transition-colors opacity-0 group-hover:opacity-100"
                title="Remove skill"
            >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5}
                        d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
    );
};

export default SkillAnalyzerCard;
